module.exports = __webpack_public_path__ + "img/plateImg0.d9571b4d.png";